import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './landingpage.css';
import { Row, Col, Badge } from 'antd';
import { LANDINGPAGE } from '../../../../../commons/api';
import localStorage from '../../../../../utils/localStorage';

const colStyle = {
  margin: '5px',
  padding: '5px',
  float: 'left',
  display: 'block',
  borderRadius: '10px',
  width: '6%',
  boxShadow: '5px 5px 30px #333333'
};

const titleStyle = {  
  fontWeight: 'bold',
  textAlign: 'center',
  marginBottom: '10px',
  borderBottom: '2px dotted black'
};

const TrainStatus = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  const [requestDeviceCheck, setRequestDeviceCheck] = useState(true);
  
  useEffect(() => {
    const assetHierarchy = async () => {
      await getDeviceList('Metro_RS');
    };
    
    assetHierarchy();
    const timeTicket = setInterval(() => {
      if (requestDeviceCheck) {
        getDeviceList('Metro_RS');
      }
    }, 10000);

    return () => clearInterval(timeTicket); // Cleanup on unmount
  }, [requestDeviceCheck]);

  const getDeviceList = async (module) => {
    let siteId = localStorage.get('currentSite') || 'test';
    let accessToken = localStorage.get('accessToken');

    const headers = {
      method: 'POST',
      url: `${LANDINGPAGE.LandingPageDeviceStatus}?SiteId=${siteId}&ModuleCode=${module}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      }
    };

    try {
      const response = await axios(headers);
      if (response.data) {
        setDeviceList(response.data);
        setRequestDeviceCheck(true);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const onCraneImageClick = (craneObject) => {
    props.navigate(`/rubus/HMI/distinctByParent/RS/${craneObject.deviceAlias}`);
  };

  const colorStatus = {
    'Main Line': '#099c0c',
    Depot: '#3397da',
    Maintenance: '#ffc300'
  };

  return (
    <div style={{ minHeight: window.innerHeight - 57 }}>
      <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
        {colorStatus &&
          Object.entries(colorStatus).map(([key, value]) => (
            <div key={key}>
              <Badge color={value} />
              <span style={{ marginRight: '10px' }}>
                {key}
              </span>
            </div>
          ))}
      </div>
      <div style={{ marginBottom: '5px', marginLeft: '4%' }}></div>

      {Array.isArray(deviceList) && deviceList.map(({ Zone, ZoneColor, ListOfDevices }) => (
        <Row key={Zone} className={Zone}>
          <Col span={24}>
            <h3
              style={{
                marginTop: '10px',
                textAlign: 'center',
                
                fontWeight: 'bold'
              }}
            >
              {Zone}
            </h3>
            <div
              style={{
                height: '10px',
                margin: '10px 22px',
                background: ZoneColor
              }}
            ></div>
            <div style={{ marginLeft: '40px' }}>
              {Array.isArray(ListOfDevices) && ListOfDevices.map((key, index) => (
                <Col
                  key={index}
                  className="colRunning"
                  style={{
                    ...colStyle,
                    backgroundColor: key && key.color ? key.color : ''
                  }}
                  onClick={() => onCraneImageClick(key)}
                  width={'7%'}
                >
                  <div style={titleStyle}>{key.deviceName}</div>
                  <div className={'stop123'}></div>
                </Col>
              ))}
            </div>
          </Col>
        </Row>
      ))}
    </div>
  );
};

export default TrainStatus;
